"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function () { return ({
    root: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0
        }
    },
    avatar: {
        width: 30,
        height: 30
    },
    button: {
        justifyContent: 'flex-start'
    },
    q: {
        textTransform: 'none',
        marginLeft: 10,
        textAlign: 'left'
    }
}); });
exports.QAContent = function (_a) {
    var question = _a.question, onClick = _a.onClick, info = _a.info;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.CardContent, { className: clsx_1.default('faq-panel-content', classes.root) },
        react_1.default.createElement(core_1.Button, { color: "inherit", fullWidth: true, className: classes.button, onClick: onClick },
            react_1.default.createElement(core_1.Avatar, { className: classes.avatar }, info ? '!' : 'Q'),
            react_1.default.createElement(core_1.Typography, { className: classes.q, variant: "h5" }, question))));
};
//# sourceMappingURL=QAContent.js.map